module.exports = __webpack_public_path__ + "static/media/nomi.69f0ebfb.png";